import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import "./DashboardEntryPanasonicResellerWidget.scss";
import UIService from "../../../services/UIService";
import VendorContext from "../../../contexts/VendorContext";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";

type Props = {
    updateDetails: (details: any) => void;
    sectionInEditMode: (section: string, inEditMode: boolean) => void;
};

export const DashboardEntryPanasonicResellerWidget = (props: Props) => {
    const vendorModel = useContext(VendorContext);
    const isMainViewLight = UIService.isMainViewLight();

    const prefDistributorOptions: { name: string }[] = [{ name: "TD SYNEX" }, { name: "Ingram Micro" }, { name: "Not Applicable" }];

    const [editMode, setEditMode] = useState(false);
    const [reseller, setReseller] = useState(vendorModel.name || "");
    const [email, setEmail] = useState(vendorModel.email || "");
    const [phone, setPhone] = useState(vendorModel.phone || "");
    const [prefDist, setPrefDist] = useState("");
    const [salesRep, setSalesRep] = useState("");

    useEffect(() => {
        props.sectionInEditMode("reseller", editMode);
        if (!editMode) {
            props.updateDetails({
                reseller,
                email,
                phone,
                prefDist,
                salesRep,
            });
        }
    }, [editMode]);

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const labelClass = "w-9r text-end mb-3 me-2";

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const _name = e.target.name;

        switch (_name) {
            case "reseller":
                setReseller(value);
                break;

            case "email":
                setEmail(value);
                break;

            case "phone":
                setPhone(value);
                break;

            case "pref_distributor":
                setPrefDist(value);
                break;

            case "sales_rep":
                setSalesRep(value);
                break;
        }
    };

    return (
        <div className={"DashboardEntryPanasonicResellerWidget col-3"}>
            <div className={"d-flex justify-content-between"}>
                <OwLabel title={"reseller"} isBold={true} />

                <OwLabel
                    title={editMode ? "save" : "edit"}
                    fn={() => {
                        toggleEditMode();
                    }}
                />
            </div>
            <div className={"card d-flex font-weight-bold card-header flex-grow h-100 " + (!isMainViewLight ? "text-white bg-dark" : "")}>
                <table className={"table " + (isMainViewLight ? "" : "table-dark")}>
                    <tbody>
                        <tr>
                            <th className={"text-end w-10r"}>
                                <OwLabel title={"reseller"} isBold={true} />
                            </th>
                            <td>{reseller}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"email"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"email"} value={email} /> : email}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"phone"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"phone"} value={phone} /> : phone}</td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"pref_distributor"} isBold={true} />
                            </th>
                            <td>
                                {editMode ? (
                                    <OwSelectOption
                                        fn={handleChange}
                                        titleProp={"name"}
                                        valueProp={"name"}
                                        name={"pref_distributor"}
                                        options={prefDistributorOptions}
                                        selectedOption={prefDist}
                                        hasSelectedOptionProp={false}
                                    />
                                ) : (
                                    prefDist
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th className={"text-end"}>
                                <OwLabel title={"panasonic_sales_rep"} isBold={true} />
                            </th>
                            <td>{editMode ? <OwFnInput fn={handleChange} name={"sales_rep"} value={salesRep} /> : salesRep}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
